module.exports = __webpack_public_path__ + "static/physician-img-213fab1268da18f551c3937829bff475.jpg";